export default __webpack_public_path__ + "static/media/14.373f9484.jpeg";